/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const renameOrganisationDataSchema = z.object({
	name: z.string(),
})

export type RenameOrganisationDataSchema = z.infer<typeof renameOrganisationDataSchema>
